import { createPubSub, getSvgSpritePath, parseHtmlToDom } from 'js/tools';
import inputCheckboxAPI from 'components/inputCheckbox/inputCheckbox';
import ToolTips from 'js/toolTips';

export default context => {
    const GROUPNAME = context.getAttribute('data-group-name');
    const hasGroupName = GROUPNAME !== null;

    const availableDisplayModes = ['stacked', 'inline'];

    const refs = {
        checkboxes: context.querySelectorAll('input'),
        checkboxWrapper: context.querySelector('ul')
    };

    const pubsub = createPubSub();

    function getCheckboxes() {
        return context.querySelectorAll('input');
    }

    function updateState(options) {
        refs.checkboxWrapper.innerHTML = '';

        options.forEach(option => {
            if (hasGroupName) {
                option.name = GROUPNAME;
            }

            const checkbox = createCheckbox(option);
            const li = document.createElement('li');

            li.className = 'checkbox-group__item';
            li.appendChild(checkbox);

            refs.checkboxWrapper.appendChild(li);
        });

        // Re-bind tooltips after state update
        window.viabovag.toolTips = new ToolTips();

        if (options.length) {
            context.hidden = false;
        } else {
            context.hidden = true;
        }
    }

    function getValues() {
        const currentCheckboxes = getCheckboxes();
        const values = [];

        currentCheckboxes.forEach(checkbox => {
            if (checkbox.checked) {
                values.push(checkbox.value);
            }
        });

        return values;
    }

    function hasValue() {
        return getValues().length > 0;
    }

    function createCheckbox(option) {
        const hasIcon = typeof option.icon !== 'undefined';
        const hasTooltip = typeof option.tooltip !== 'undefined';

        const containerDiv = document.createElement('div');
        if (hasTooltip) {
            containerDiv.className = 'checkbox-group__item--with-tooltip';
        }

        /* eslint-disable max-len */
        const checkbox = parseHtmlToDom(`
            <div class="input-checkbox ${hasIcon ? 'input-checkbox--with-icon' : ''}">
                <input type="checkbox" name="${option.name}" id="${option.name}_${option.value}" value="${
            option.value
        }" ${option.checked ? 'checked' : ''}/>
                <label for="${option.name}_${option.value}">
                    <span class="input-checkbox__checkmark">
                        <svg class="icon-checkbox" xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 19">
                            <g fill="none" fill-rule="evenodd">
                                <g fill="#000">
                                    <path fill="none" d="M-3-2h24v24H-3z"></path>
                                    <path fill-opacity=".38" d="M16 3v14H2V3h14zM2 1C.9 1 0 1.9 0 3v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H2z" opacity=".54"></path>
                                    <path fill="#FFF" d="M2 3h14v14H2z"></path>
                                </g>
                                <path class="icon-checkbox__checkmark" fill="#049C4B" fill-rule="nonzero" d="M7.568 11.257L3.975 7.714 2 9.662l4.741 4.675.871.848L20.995 1.986 18.982 0z"></path>
                            </g>
                        </svg>
                    </span>

                    <span class="input-checkbox__text">
                        ${option.label}
                        ${
                            'count' in option
                                ? `<span class="input-checkbox__count">(${option.count.toLocaleString('nl-NL')})</span>`
                                : ''
                        }
                    </span>
                </label>
            </div>
        `);
        /* eslint-enable max-len */

        if (hasIcon) {
            const label = checkbox.querySelector('label');

            const imagery = parseHtmlToDom(`
                <span class="input-checkbox__imagery">
                    <svg class="icon-${option.icon}">
                        <use xlink:href="${getSvgSpritePath()}#${option.icon}"></use>
                    </svg>
                </span>
            `);

            label.appendChild(imagery);
        }

        checkbox.jsApi = inputCheckboxAPI(checkbox);
        bindCheckboxEvents(checkbox);

        containerDiv.append(checkbox);

        if (hasTooltip) {
            const toolTip = parseHtmlToDom(`
                <span class="more-info" data-tooltip="" data-tippy-content="${option.tooltip}" aria-expanded="false">
                    <svg class="icon-info">
                    <use xlink:href="${getSvgSpritePath()}#info"></use>
                    </svg>
                    <span class="more-info__click-area"></span>
                </span>`);

            containerDiv.append(toolTip);
        }

        return containerDiv;
    }

    function bindCheckboxEvents(checkbox) {
        checkbox.addEventListener('change', () => pubsub.publish('change'));
    }

    function clearDisplayModes() {
        availableDisplayModes.forEach(displayMode => context.classList.remove(`checkbox-group--${displayMode}`));
    }

    function setDisplayMode(displayMode) {
        clearDisplayModes();
        context.classList.add(`checkbox-group--${displayMode}`);
    }

    refs.checkboxes.forEach(checkbox => bindCheckboxEvents(checkbox));

    return {
        subscribe: pubsub.subscribe,
        updateState,
        setDisplayMode,
        hasValue
    };
};
